module.exports = __webpack_public_path__ + "media/components/landing_pages/smart_storage_v2/images/check-f81a8c63cd8b890db0dbb44331d35021.svg";